const createMuiListStyles = () => ({
    styleOverrides: {
        root: {
            padding: '0',
        },
    },
});

const createMuiListSubheaderStyles = () => ({
    styleOverrides: {
        root: {
            fontSize: '1rem',
            fontWeight: 'bold',
        },
    },
});

export { createMuiListStyles, createMuiListSubheaderStyles };
